import React, { use, useEffect, useState } from "react";
import "../../../incidents/cases/addCaseList.scss";
import FilterListIcon from "@mui/icons-material/FilterList";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../../library/custom/button/Button";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import ReportRowManipulte from "../../shared/ReportRowManipulate";
import { TableLoader } from "../../../../library/common/Loader";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import {
  API_ADMIN_STATUS_STATUS,
  HBNEXT_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
} from "../../../../constant/constant";
import NORow from "../../../../library/custom/noRow/noRow";
import DialogBox from "../../../../library/common/DialogBox";
import FilterCommonStatusSelect from "../../shared/FilterCommonStatusSelect";
import "./viewContact.scss";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { PRODUCT_ID } from "../../../../constant/storm-water/constant";
import { encodeSearchText, InactiveClient } from "../../../../utils/helper";
import check_Icon from "../../..../../../../assets/check_Icon.svg";
import cross_Icon from "../../..../../../../assets/cross_Icon.svg";
import verifyEmailCheckBox from "../../..../../../../assets/verifyEmailCheckBox.svg";
import { Grid } from "@mui/material";

export default function ContactList({
  contacts,
  addContact,
  getContactListData,
  isLoading,
  handleDeleteOnClick,
  handleViewOnClick,
  handleEditOnClick,
  selectedServiceTypeData,
  sendBulkEmailVarifation,
  setClickVerifyBtn,
  setAccessUserId,
  accessUserId,
  contact,
  shouldRestoreState,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [contactFilterData, setContactFilterData] = useState({
    isSendMail: false,
  });
  const [filter, setFilter] = useState({
    searchType: [],
  });
  const [statusIds, setStatusIds] = useState();
  const [isTableLoading, setisTableLoading] = useState(false);
  // const [accessUserId, setAccessUserId] = useState([]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteContact = (divisionId) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(divisionId);
  };
  const deletehandle = () => {
    setOpenModal(false);
    handleDeleteOnClick(selectedRow);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const open = Boolean(anchorEl);
  const isShowClient =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const id = open ? "simple-popover" : undefined;
  const columns = [
    { field: "name", headerName: "Name", flex: 1.4 },
    { field: "designation", headerName: "Job Title", flex: 1.2 },
    { field: "companyName", headerName: "Company", flex: 1.2 },
    { field: "contactNo", headerName: "Phone Number", flex: 1.8 },
    {
      field: "email",
      headerName: "Email ID",
      flex: 3.2,
      renderCell: (rows) => {
        const email = rows?.row?.email || "";
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "100%",
            }}
          >
            <div
              title={email}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
                minWidth: "0",
                textAlign: "left",
              }}
            >
              {email}
            </div>
          </div>
        );
      },
    },
    {
      field: "isEmailVerified",
      headerName: "Verified Email",
      flex: 1.7,
      renderCell: (rows) => {
        return rows?.row?.isEmailVerified ? (
          <img src={check_Icon} alt="Verified" width="16" height="16" />
        ) : (
          <img src={cross_Icon} alt="Not Verified" width="18" height="18" />
        );
      },
    },
    { field: "status", headerName: "Status", flex: 1 },
    {
      field: "",
      flex: 0.8,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            deleteOnClick={(row) => deleteContact(row?.id)}
            viewOnClick={(row) => handleViewOnClick(row?.id, row?.statusId)}
            editOnClick={(row) => handleEditOnClick(row?.id)}
            deleted={checkPrivileges([12, 40])}
            edit={checkPrivileges([12, 40, 41])}
            view={checkPrivileges([12, 40, 41, 42])}
            viewLabel="View Contact"
            deleteLabel="Delete Contact"
            editLabel="Edit Contact"
          />
        );
      },
    },
  ];
  if (parseInt(PRODUCT_ID()) === 2 && isShowClient) {
    columns.splice(-1, 0, {
      field: "global",
      headerName: "Global",
      flex: 1,
    });
  }
  useEffect(() => {
    if (shouldRestoreState && contact?.filterObj) {
      const f = contact.filterObj;
      setPage((f.page || 1) - 1);
      setSearch(f.search || "");
      setPageSize(f.pageSize || PAGE_SIZE);
      const savedStatus = f.statusIds;
      if (
        savedStatus !== undefined &&
        savedStatus !== null &&
        savedStatus !== ""
      ) {
        const statusItem = API_ADMIN_STATUS_STATUS.find(
          (item) => item.key === savedStatus,
        );
        if (statusItem) {
          setFilter({ searchType: [statusItem] });
          setStatusIds(savedStatus);
        }
      }
    }
  }, [shouldRestoreState]);
  const handleSearch = (data) => {
    setAnchorEl(null);
    getContactListData(data);
  };

  const handleautoSearch = (event, state) => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    const data = {
      ...contactFilterData,
      page: 1,
      isSendMail: false,
      pageSize: pageSize,
      search: searchText ?? "",
      statusIds: statusIds ? statusIds : "",
      compnayName: "",
    };
    setContactFilterData(data);
    getContactListData(data);
  };
  const handleClear = () => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    setPageSize(PAGE_SIZE);
    setSearch("");
    setFilter((prevState) => {
      const prevStates = { ...prevState };
      prevStates.searchType = [];
      return prevStates;
    });
    setStatusIds("");
    const data = {
      page: 1,
      pageSize: PAGE_SIZE,
      statusIds: "",
      search: "",
      compnayName: "",
      isSendMail: false,
    };
    handleSearch(data);
  };
  const handleApply = () => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    const data = {
      page: 1,
      pageSize: pageSize,
      statusIds: statusIds ? statusIds : "",
      search: search,
      compnayName: "",
      isSendMail: false,
    };
    setContactFilterData(data);
    handleSearch(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      ...contactFilterData,
      page: newPage + 1,
      pageSize: pageSize,
      statusIds: statusIds ? statusIds : "",
      compnayName: "",
      search: search,
      isSendMail: false,
    };
    setContactFilterData(data);
    getContactListData(data);
  };

  const onChangeType = (item) => {
    setFilter((prevState) => {
      const prevStates = { ...prevState };
      const searchType = prevStates.searchType;
      const filter =
        searchType && searchType.filter((its) => its?.key === item?.key);
      if (filter[0] === undefined) {
        prevStates.searchType = [item];
        setStatusIds(item?.key);
      } else {
        prevStates.searchType = [];
      }
      return prevStates;
    });
  };

  const onRowClick = (rows) => {
    if (rows.value) {
      sessionStorage.setItem("contactListPreserveState", "true");
      handleViewOnClick(rows?.id);
    }
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPage(0);
    setPageSize(newPazeSize);
    getContactListData({
      page: 1,
      pageSize: newPazeSize,
      statusIds: statusIds ? statusIds : "",
      compnayName: "",
      search: search,
      isSendMail: false,
    });
  };
  const sendEmail = () => {
    const data = {
      page: page + 1,
      pageSize: pageSize,
      statusIds: statusIds ? statusIds : "",
      search: search,
      compnayName: "",
      isSendMail: true,
    };
    setContactFilterData(data);
    getContactListData(data);
  };
  const sendBulkEmailVerify = () => {
    if (accessUserId?.length > 0) {
      setClickVerifyBtn(true);
      const data = {
        ids: accessUserId,
        type: 2,
      };
      sendBulkEmailVarifation(data);
    }
  };
  return (
    <>
      <section className="grid_main_sec">
        {openModal && (
          <DialogBox
            open={openModal}
            rows={[]}
            header={"Confirm Deletion"}
            deletehandle={deletehandle}
            handleCloseModal={() => setOpenModal(false)}
            content={"Are you sure you want to delete this Contact?"}
            view
          />
        )}
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Contacts</div>
          <div>
            {checkPrivileges([12, 40, 41]) && (
              <Buttons
                id="btnAddContact"
                label={"Add Contact"}
                varientAddIconBlue={true}
                onClick={() => addContact()}
              />
            )}
          </div>
        </div>
        <div className={accessUserId?.length > 0 ? "userMain" : ""}>
          {" "}
          <div className="grid_main_body">
            <Grid
              container
              className="fixedDesign div-filter-container gapNone"
            >
              <Grid item sm={6} md={6} xs={12}>
                <div className="filter_of_caselist">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>
                  <div className="filter_btn">
                    <button
                      aria-describedby={id}
                      variant="contained"
                      type="button"
                      name="btn"
                      onClick={(e) => handleClick(e)}
                    >
                      <FilterListIcon id="icn" /> Filters
                    </button>

                    <FilterCommonStatusSelect
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      handleApply={handleApply}
                      handleClear={handleClear}
                      filter={filter}
                      statusType={API_ADMIN_STATUS_STATUS}
                      onChangeType={onChangeType}
                      statusIds={statusIds}
                      filterSelect={false}
                      filterStatus={true}
                      resetBtn={true}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item sm={6} md={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item md={7} xs={12} className="emailRight">
                    {accessUserId?.length > 0 && (
                      <div
                        className={`div-verify-email-right ${
                          accessUserId?.length === 0 ? "asscssuser" : ""
                        }`}
                        onClick={sendBulkEmailVerify}
                      >
                        <span>
                          <img
                            src={verifyEmailCheckBox}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Verify Selected Emails
                      </div>
                    )}
                  </Grid>
                  <Grid item md={5} xs={12}>
                    <div
                      className="div-download-email-right"
                      onClick={sendEmail}
                    >
                      <span>
                        <img
                          src={downloadIcon}
                          className="DownLoadLogo"
                          alt="DownLoad Logo"
                        />
                      </span>
                      Download Data
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <GridTable
                    getRowId={(r) => r.id}
                    rows={contacts?.result?.contactData ?? []}
                    rowCount={contacts?.result?.noOfRecords ?? 0}
                    columns={columns}
                    loading={isLoading}
                    checkboxSelection={true}
                    page={page}
                    //  onClick={(rows) => onRowClick(rows)}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePagignation}
                    backIconButtonProps={{ disabled: false }}
                    disableSelectionOnClick
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    isRowSelectable={(params) =>
                      params?.row?.isEmailVerified === false
                    }
                    onSelectionModelChange={setAccessUserId}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
